<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'originality'
};
</script>

<style>
</style>
